module.exports = __webpack_public_path__ + "static/media/LemonSelfie.fcf829ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/IoT/LemonSelfie.png
// module id = 468
// module chunks = 0